export default __webpack_public_path__ + "static/media/May_18_2023_Cafe_Beaujolais.6c5a9b1b.jpg";